module.exports = " <div class=tab_bar _v-15b80bca=\"\"> <div v-link=\"{ name: 'login' }\" :class=\"{ active: $route.name === 'login' }\" _v-15b80bca=\"\">登录</div> <div v-link=\"{ name: 'register' }\" :class=\"{ active: $route.name === 'register' }\" _v-15b80bca=\"\">注册</div> </div> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-15b80bca!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/TabBar.vue
 ** module id = 333
 ** module chunks = 2
 **/